<template>
<div>
    <b-navbar toggleable="lg" type="dark" variant="primary">

        <b-navbar-brand :to="{name:'Home'}" class="Oleo" exact>
            ECER
        </b-navbar-brand>

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
        <b-collapse id="nav-collapse" is-nav>
            <!-- Right aligned nav items -->
            <b-navbar-nav class="ml-auto">
                <b-navbar-nav>
                    <b-nav-item>
                        <router-link class="nav-link" to="/login">Login</router-link>
                    </b-nav-item>

                </b-navbar-nav>
            </b-navbar-nav>
        </b-collapse>
    </b-navbar>

</div>
</template>

<script>
export default {
    name: 'BarraNavegar'
}
</script>

<style>

</style>
